export const navigation = {
  'Go back': 'Go back',
  'Go forward': 'Go forward',
};
